import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";

const state = {
  errors: null,
  collection: [],
};

const getters = {
  itemCollection(state) {
    return state.collection;
  },

  getItemByID: (state) => (id) => {
    return state.collection.find((item) => item.id == id);
  },
};

const actions = {
  fetchItem(context) {
    let appLocale = i18nService.getActiveLanguage();
    ApiService.get("inventory/item")
      .then(({ data }) => {
        // create localized fields
        let dataLocalized = data.map((item) => {
          if (item.translations[appLocale]) {
            item.name = item.translations[appLocale].name;
          } else {
            item.name =
              item.translations[Object.keys(item.translations)[0]].name;
          }

          item.ReferenceName = item.reference + " | " + item.name;
          return item;
        });

        context.commit("fetchItem", dataLocalized);
      })
      .catch((error) => {
        console.log("Error!: ", error);
      });
  },
};

const mutations = {
  fetchItem(state, data) {
    state.collection = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
